import { combineReducers } from 'redux';
import cartReducer from './index';

const rootReducer = combineReducers({
    cartReducer
});

export default rootReducer; 